import type { ReactNode } from 'react';

type SelectionBarProps = {
  /** Текущее количество выбранных элементов. Если 0 — не отображается. */
  count: number;
  /** Доп-описание (например, «из 124 файлов»). */
  hint?: ReactNode;
  /** Кнопки действий справа. */
  children: ReactNode;
};

/**
 * Sticky-полоса в нижней части модуля-источника, появляется когда выбран
 * хотя бы один элемент. Сюда выносим bulk-действия (сохранить, удалить, очистить).
 * Если count = 0, ничего не рендерим.
 */
const SelectionBar = ({ count, hint, children }: SelectionBarProps) => {
  if (count <= 0) return null;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 16px',
        background: 'var(--shell-bg-surface)',
        borderTop: '1px solid var(--shell-border-subtle)',
        flexShrink: 0,
        fontSize: 13,
        boxShadow: 'var(--shell-shadow-2)',
      }}
    >
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '4px 10px',
          background: 'var(--shell-accent-subtle)',
          border: '1px solid var(--shell-accent-primary)',
          borderRadius: 'var(--shell-radius-pill)',
          color: 'var(--shell-accent-pressed)',
          fontWeight: 600,
          fontSize: 12,
        }}
      >
        Выбрано: {count}
      </div>
      {hint && <span style={{ color: 'var(--shell-text-tertiary)', fontSize: 12 }}>{hint}</span>}
      <div style={{ flex: 1 }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{children}</div>
    </div>
  );
};

export default SelectionBar;
